import { IRCMessage } from "../../irc/irc-message";

export class ReconnectMessage extends IRCMessage {}
